/**
 * Payment status
 */
export const PaymentStatus = {
  /**
   * Payment has been initiated by account
   */
  Initiated: 'initiated',
  /**
   * Payment has been completed
   */
  Completed: 'completed',
  /**
   * Payment has been cancelled
   */
  Cancelled: 'cancelled',
  /**
   * Payment failed with unexpected error
   */
  Error: 'error'
}
